<template>
  <div class="row">
    <div class="col-md-12">
      <b-tabs v-model="tab">
        <b-tab :title="$t('quran_programs.live_meetings')">
          <data-table :edit-item="editItem" :code="code" />
        </b-tab>
        <b-tab @click="newItem = { code }" :title="$t('site.add')" v-if="$role == 'super_admin'||$role == 'QuranAdmin' &&$route.name!='QuranScheduleDateNow'">
          <my-form :new-item="newItem" />
        </b-tab>
      </b-tabs>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
  <!-- end of row -->
</template>

<script>
import DataTableVue from "./components/DataTable.vue";
import FormVue from "./components/Form.vue";

export default {
  name: "ApologyIndex",
  components: {
    "data-table": DataTableVue,
    "my-form": FormVue,
  },
  data() {
    return {
      newItem: {},
      tab: 0,
      code: 2000,
    };
  },
  methods: {
    editItem(data) {
      this.newItem = data.item;
      this.tab = 1;
    },
  },
};
</script>
